import React, { useEffect } from 'react';

const BlogView = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const articles = [
        {
            title: "5 Essential Vitamins for Winter Immunity",
            category: "Wellness",
            date: "Dec 10, 2023",
            readTime: "4 min read",
            summary: "Discover the top vitamins you need to keep your immune system strong during the colder months.",
            image: "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
        },
        {
            title: "Understanding Generic vs. Branded Medicines",
            category: "Education",
            date: "Nov 28, 2023",
            readTime: "6 min read",
            summary: "What's the real difference between branded medicines and their generic alternatives? We break down the facts.",
            image: "https://images.unsplash.com/photo-1585435557343-3b092031a831?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
        },
        {
            title: "Managing Hypertension with Diet and Medication",
            category: "Health Guide",
            date: "Nov 15, 2023",
            readTime: "8 min read",
            summary: "A comprehensive guide to keeping your blood pressure in check through lifestyle changes and proper adherence.",
            image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
        }
    ];

    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6">
            <div className="max-w-6xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-bold text-slate-800">Health Blog</h1>
                    <p className="text-lg text-slate-500">Expert advice, health tips, and wellness guides.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {articles.map((article, idx) => (
                        <div key={idx} className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden flex flex-col hover:shadow-md transition-shadow cursor-pointer">
                            <div className="h-48 overflow-hidden relative">
                                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-sky-700 text-xs font-bold px-3 py-1 rounded-full z-10 shadow-sm">
                                    {article.category}
                                </div>
                                <img src={article.image} alt={article.title} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" />
                            </div>
                            <div className="p-6 flex-grow flex flex-col">
                                <div className="flex items-center text-xs text-slate-400 mb-3 space-x-4">
                                    <span><i className="far fa-calendar-alt mr-1"></i> {article.date}</span>
                                    <span><i className="far fa-clock mr-1"></i> {article.readTime}</span>
                                </div>
                                <h2 className="text-xl font-bold text-slate-800 mb-3 leading-tight">{article.title}</h2>
                                <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow">{article.summary}</p>
                                <div className="text-sky-600 font-bold text-sm flex items-center hover:text-sky-700">
                                    Read Article <i className="fas fa-arrow-right ml-2 text-xs"></i>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className="text-center mt-12">
                    <button className="bg-white border-2 border-slate-200 text-slate-600 px-8 py-3 rounded-xl font-bold hover:border-slate-300 hover:bg-slate-50 transition-colors">
                        Load More Articles
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlogView;
